import {
    AxiosError,
    AxiosInstance,
    InternalAxiosRequestConfig,
} from "axios";

import { refreshManager } from "./refresh.manager";

type RetryRequest = InternalAxiosRequestConfig & {
    _retry?: boolean;
    _skipAuthRefresh?: boolean;
};

/**
 * Routes pour lesquelles on ne tente JAMAIS de refresh.
 */
const SKIP_REFRESH_PATTERNS = [
    "/auth/refresh",
    "/auth/login",
    "/auth/register",
    "/auth/forgot-password",
    "/auth/verify-reset-code",
    "/auth/reset-password",
];

const shouldSkipRefresh = (url: string): boolean => {
    return SKIP_REFRESH_PATTERNS.some((pattern) => url.includes(pattern));
};

export const setupInterceptors = (client: AxiosInstance): void => {
    client.interceptors.response.use(
        (response) => response,

        async (error: AxiosError) => {
            const status = error.response?.status;
            const originalRequest = error.config as RetryRequest;

            if (status !== 401) {
                return Promise.reject(error);
            }

            if (!originalRequest) {
                return Promise.reject(error);
            }

            const requestUrl = originalRequest.url ?? "";

            if (
                originalRequest._skipAuthRefresh ||
                shouldSkipRefresh(requestUrl)
            ) {
                return Promise.reject(error);
            }

            if (originalRequest._retry) {
                return Promise.reject(error);
            }

            originalRequest._retry = true;

            try {
                await refreshManager.refresh(client);
                return client(originalRequest);
            } catch (refreshError) {
                return Promise.reject(refreshError);
            }
        },
    );
};